import { render, staticRenderFns } from "./PaintlistpaintshopPage.vue?vue&type=template&id=12e7b1d8"
import script from "./PaintlistpaintshopPage.vue?vue&type=script&lang=js"
export * from "./PaintlistpaintshopPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports